export function getLocalStaticFiles() {
    return require.context('../../../../../static', true);
}
